module.exports = __webpack_public_path__ + "img/sdg-front-end.png.76af9eea.webp";